import React from 'react';

const DrLawyer = () => {
  return (
    <div className="p-4">
      <h3 className="text-xl font-bold mb-2">Legal Services</h3>
      {/* Add legal service-specific content here */}
    </div>
  );
};

export default DrLawyer;